import React from "react";
import SimpleBar from "simplebar-react";

import { IconName } from "../types";
import { getPriceFormatted } from "../util";
import Icon from "./Icon";

type StyleThumbnailItem = {
  id: number;
  thumbnail: string;
  title: string;
  recommended?: boolean;
  price?: number;
};
const StyleThumbnails = (props: {
  items: StyleThumbnailItem[];
  selectedId: number;
  onClickItem?: (index: number) => void;
  imageStyle: "short" | "tall";
  activeStyle: "transparent" | "white" | "selectable";
  showPrice?: boolean;
  hideIncluded?: boolean; // Don't show price if it is 'included' ($0)
  padLeftRight?: boolean;
}) => {
  const getTitle = (item: StyleThumbnailItem) => {
    if (item.title.length > 35) {
      return item.title.substring(0, 35) + "...";
    }
    return item.title;
  };

  return (
    <div className={"pyht-style-thumbnails"}>
      <SimpleBar autoHide={false}>
        <div className={"scrollbars-inner"}>
          {props.items.map((item, index) => {
            return (
              <div
                role={"button"}
                key={index}
                className={`style-option ${
                  props.selectedId === item.id ? "active selected" : ""
                } active-style-${props.activeStyle} ${
                  props.padLeftRight ? "" : "no-pad-left-right"
                } ${props.activeStyle === "selectable" ? "pyht-selectable" : ""}
             image-style-${props.imageStyle}`}
                onClick={() => props.onClickItem && props.onClickItem(index)}
              >
                {props.activeStyle === "selectable" && (
                  <Icon name={IconName.CHECK_MARK_CIRCLE} />
                )}
                <div className={"style-thumbnail"}>
                  <img src={item.thumbnail} alt={""} />
                  {item.recommended && (
                    <div className={"recommended"}>Recommended</div>
                  )}
                </div>
                <div className={"thumbnail-title"}>
                  <span>{getTitle(item)}</span>
                  {props.showPrice && (!!item.price || !props.hideIncluded) && (
                    <p className={"thumbnail-price"}>
                      {getPriceFormatted(item.price)}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </SimpleBar>
    </div>
  );
};

export default StyleThumbnails;
